export const ReferAFriendIcon = ({className}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path d="M15.74,38.078,10.24,42.8A.75.75,0,0,1,9,42.232v-2.72c-4.847.069-6.936,1.272-5.519,5.8A.556.556,0,0,1,2.6,45.9,6.384,6.384,0,0,1,0,41.081c0-4.756,3.981-5.762,9-5.822v-2.5a.751.751,0,0,1,1.24-.567l5.5,4.722A.78.78,0,0,1,15.74,38.078Z" transform="translate(2 -29.01)"/>
    </svg>
  )
}